import { profileQueryOptions, profileSelectors } from "@stryker/core/queries";
import { useQuery } from "@tanstack/react-query";
import BurgerIcon from "@/assets/icons/burger.svg?react";
import ChevronIcon from "@/assets/icons/chevron.svg?react";
import InfoIcon from "@/assets/icons/info.svg?react";
import ContactSupportButton from "@/components/ContactSupportButton";
import { Typography } from "@/components/ui/typography";
import useOrganization from "@/hooks/useOrganization";
import useScreens from "@/hooks/useScreens";
import { cn } from "@/lib/utils";
import useSidebarStore from "@/store/useSidebarStore";

export default function Toolbar() {
  const { toggleSidebar, isOpen } = useSidebarStore();
  const isTabletOrMore = useScreens("md", "up");
  const { data: isAdmin } = useQuery({
    ...profileQueryOptions(),
    select: profileSelectors.isAdmin,
  });
  const { data: organization } = useOrganization();

  if (isTabletOrMore) {
    return (
      <div className="flex h-[70px] w-full items-center justify-between gap-4 bg-gray-50 p-4">
        <button
          className="cursor-pointer z-40 flex h-8 w-8 items-center justify-center rounded-lg bg-white"
          onClick={toggleSidebar}
        >
          <ChevronIcon className={cn("hidden md:block", !isOpen && "rotate-180")} />
        </button>
        <div className="flex  items-center gap-2">
          <div className="mr-4 flex gap-1">
            <InfoIcon />
            <Typography variant="text-small" weight="semibold">
              {organization?.balanceValue} credits
            </Typography>
          </div>
          {isAdmin && <ContactSupportButton variant="outline" subject="Credits" />}
        </div>
      </div>
    );
  }

  return (
    <div className="sticky top-0 z-40 flex items-center gap-4 bg-gray-50 px-4 py-4">
      <Typography variant="text-xl" weight="semibold">
        Stryker
      </Typography>
      <Typography variant="text-small" weight="semibold">
        {organization?.balanceValue} credits
      </Typography>
      <BurgerIcon className="ml-auto" onClick={toggleSidebar} />
    </div>
  );
}
